import { BenchOption, EquipmentRequiringInstruction } from 'fitbeat.models';
import { Exercise } from '../../../../entities/exercise/exercise';

export interface IEquipmentInstructionInfo {
    equipment: EquipmentRequiringInstruction;
    resistance: string;
}

export class EquipmentInstructions {
    public static setupBenchInstructionImageUrl(exercise: Exercise): string | undefined {
        const options = exercise.homeBenchSetupOptions;
        if (options == null || options.length < 1) {
            return undefined;
        }
        // assume first is correct, need to check this assumption
        // , but not sure what to show if not
        const firstOption = options[0];
        const urlBase = 'https://res.cloudinary.com/fitbeat-operations/image/upload/'
                      + 'c_scale,q_auto:good,w_1080/elite-instructions/2023-05-16/';
        switch (firstOption) {
            case BenchOption.Flat : return urlBase + `BenchDrawings_Flat.png`;
            case BenchOption.Opt1 : return urlBase + `BenchDrawings_Option_1.png`;
            case BenchOption.Opt2 : return urlBase + `BenchDrawings_Option_2.png`;
            case BenchOption.Opt3 : return urlBase + `BenchDrawings_Option_3.png`;
            case BenchOption.Opt4 : return urlBase + `BenchDrawings_Option_4.png`;
            case BenchOption.Opt5 : return urlBase + `BenchDrawings_Option_5.png`;
            case BenchOption.Opt6 : return urlBase + `BenchDrawings_Option_6.png`;
            case BenchOption.Opt7 : return urlBase + `BenchDrawings_Option_7.png`;
            case BenchOption.Opt8 : return urlBase + `BenchDrawings_Option_8.png`;
            case BenchOption.Opt9 : return urlBase + `BenchDrawings_Option_9.png`;
            case BenchOption.Opt10 : return urlBase + `BenchDrawings_Option_10.png`;
            case BenchOption.Opt11 : return urlBase + `BenchDrawings_Option_11.png`;
            case BenchOption.Opt12 : return urlBase + `BenchDrawings_Option_12.png`;
            case BenchOption.Opt13 : return urlBase + `BenchDrawings_Option_13.png`;
            case BenchOption.Opt14 : return urlBase + `BenchDrawings_Option_14.png`;
            case BenchOption.Opt15 : return urlBase + `BenchDrawings_Option_15.png`;
            case BenchOption.Opt16 : return urlBase + `BenchDrawings_Option_16.png`;
            case BenchOption.Opt17 : return urlBase + `BenchDrawings_Option_17.png`;
            case BenchOption.Opt18 : return urlBase + `BenchDrawings_Option_18.png`;
            case BenchOption.Opt19 : return urlBase + `BenchDrawings_Option_19.png`;
            case BenchOption.Opt20:  return urlBase + `BenchDrawings_Option_20.png`;
            default: return undefined;
        }
    }
}
